import React from 'react';
import { motion } from 'framer-motion';
import Scene3D from './components/Scene3D';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingContact from './components/FloatingContact';
import './styles/App.css';

function App() {
    return (
        <div className="App">
            <Scene3D />
            <Header />
            <motion.main
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <Hero />
                <About />
                <Skills />
                <Projects />
                <Experience />
                <Contact />
            </motion.main>
            <Footer />
            <FloatingContact />
        </div>
    );
}

export default App;